import { isNormalUser } from "@/utils/roleStorage";

export const TaleBorderFul = ({
  children,
  width,
  height,
  role,
  customBackground,
  className = "",
  bgClassName = "",
  directContainerClassName = "",
  ...props
}) => {
  return (
    <div
      className={`z-0 relative rounded-lg p-[2px] ${className ?? ""}`}
      style={{
        width,
        height,
      }}
      {...props}
    >
      <div
        className={`absolute top-0 left-0 !-z-10 w-full h-full rounded-lg ${
          customBackground ||
          (isNormalUser() ? "bg-tale-normal" : "bg-tale-business")
        } ${bgClassName ?? ""}`}
      />
      <div
        className={`flex items-center justify-center !z-20 size-full outline-none bg-white rounded-md overflow-hidden ${directContainerClassName ?? ""}`}
      >
        {children}
      </div>
    </div>
  );
};
